var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUp = function SvgIconUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.046 15.267V22h3.908v-6.733zM6 15.267h12L12.637 2h-1.274z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 22V2h12v20z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 24.6,
    height: 24.6,
    x: -0.3,
    y: -0.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "0.5 0.5",
    numOctaves: 3,
    seed: 4679,
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    width: "100%",
    height: "100%",
    "in": "shape",
    result: "displacedImage",
    scale: 0.6,
    xChannelSelector: "R",
    yChannelSelector: "G"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_10377_14781"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "displacedImage"
  }))))));
};
export default SvgIconUp;